import React from "react";
import styles from "../../asset/Service/Artwork.module.scss";
import WhoWeAreImage from "../../asset/homefour/printdesign/printdesign1.webp";
import WhoWeAreImage2 from "../../asset/homefour/printdesign/printdesign2.webp";
import WhoWeAreImage3 from "../../asset/homefour/printdesign/printdesign3.webp";
import { Link } from "react-router-dom";


const PrintDesign = () => {
  const artworks = [
    {
      img: WhoWeAreImage,
      title: "Catalogs",
      link: "/portfolio/4",
    },
    {
      img: WhoWeAreImage2,
      title: "Labels & Scaling",
      link: "/portfolio/14",
    },
    // {
    //   img: WhoWeAreImage,
    //   title: "Mockup",
    //   link: "#",
    // },
    {
      img:  WhoWeAreImage3,
      title: "Separations",
      link: "/portfolio/16",
    },
  ];

  return (
    <section className={styles.artworkSection}>
      <div className={styles.container}>
        <h2 className={styles.title}>Print Design</h2>
        <p className={styles.description}>
         Our print design capabilities transform your concepts into compelling messages through highly creative visual expression. Our services cover a broad range of print design needs, including complete marketing collateral, visual identity, business stationery, signage, packaging, catalogs, and publications.

        </p>
                <p className={styles.description}>
                  Marketing collateral includes brochures, flyers, newsletters, banners, posters, postcards, gift cards, and more. We also deliver a comprehensive corporate identity (ID) kit consisting of business cards, letterheads, envelopes, invoices, message slips, and notepads—each designed to leave a lasting brand impression.
</p>

        <div className={styles.grid}>
          {artworks.map((item, index) => (
            <div key={index} className={styles.card}>
              <img src={item.img} alt={item.title} className={styles.image} />
              <div className={styles.cardContent}>
                <h3>{item.title}</h3>
                   <Link to={item.link} className={styles.arrowBtn}>
                   →
                 </Link>
              </div>
            </div>
          ))}
        </div>

        {/* <div className={styles.faqSection}>
          <p>
            Want to know more? Look up our FAQ page or speak to our responsive
            customer support team.
          </p>
          <button className={styles.faqBtn}>Let's get started</button>
        </div> */}
      </div>
    </section>
  );
};

export default PrintDesign;
